import {
  ref
} from "vue";
import {
  defineStore
} from "pinia";

import {
  getGameSettings,
  updateGameSettings
} from "@/api/settingsApi.js";
import {
  DEFAULT_SKIN_SELECTION,
  normalizeSkinSelection
} from "@/game/runtime/systems/skinService.js";
import {
  gameRuntimeBridge
} from "@/game/bridge/runtimeBridge.js";


export const useSkinStore =
  defineStore(
    "skin",
    () => {
      const selection = ref({
        ...DEFAULT_SKIN_SELECTION
      });

      const loading = ref(false);
      const saving = ref(false);
      const loadError = ref(null);
      const saveError = ref(null);


      async function applyRemote(
        settings
      ) {
        selection.value =
          normalizeSkinSelection({
            ball:
              settings.ballSkinCode,
            paddle:
              settings.paddleSkinCode
          });

        await gameRuntimeBridge.setSkin(
          selection.value
        );

        return selection.value;
      }


      async function refresh() {
        loading.value = true;
        loadError.value = null;

        try {
          const settings =
            await getGameSettings();

          return await applyRemote(
            settings
          );
        } catch (error) {
          loadError.value = error;
          throw error;
        } finally {
          loading.value = false;
        }
      }


      async function select(
        category,
        skinId
      ) {
        if (
          saving.value
          || !["ball", "paddle"]
            .includes(category)
        ) {
          return selection.value;
        }

        saving.value = true;
        saveError.value = null;

        try {
          const patch =
            category === "ball"
              ? {
                  ballSkinCode:
                    skinId
                }
              : {
                  paddleSkinCode:
                    skinId
                };

          const settings =
            await updateGameSettings(
              patch
            );

          return await applyRemote(
            settings
          );
        } catch (error) {
          saveError.value = error;
          throw error;
        } finally {
          saving.value = false;
        }
      }


      return {
        selection,
        loading,
        saving,
        loadError,
        saveError,
        refresh,
        select
      };
    }
  );
